import React from 'react';
import {t} from 'i18next';
import {IElementQuestionnaire} from '../../../../incase-domain/elements/base/questionElementBase';
import Button from '../../../../incase-domain/components/button/Button';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';

interface ResultsButtonProps {
    element: IElementQuestionnaire;
    device: DeviceType;
}

function ResultsButton(props: ResultsButtonProps): JSX.Element {
    const {element, device} = props;

    return (
        <Button
            className={`c-questionLayout__showResultsButton c-questionLayout__showResultsButton--${
                device === DeviceType.MOBILE ? 'mobile' : ''
            }`}
            variant="outline"
            color={element.isDebatable ? 'warning' : 'info'}
            size="md"
            dynamicSize
            fullWidth
        >
            <span>{t('common.results')}</span>
        </Button>
    );
}

export default ResultsButton;
